import { createModel } from '@/store/tools';
import { isPlat, isOC } from '@/assets/js/authType';

const model = {
    namespace: 'deliveryticket',
    build: (T, A, S, R, C) => ({
        actiontypes: {
            'getfindList': T('getfindList'), // 罚单--列表
            'getdetail': T('getdetail'), // 罚单--详情
            'getfindNames': T('getfindNames'), // 罚单--处罚原因
            'getPunishmentStateEnum': T('getPunishmentStateEnum'), // 罚单--状态
        },
        actions: {
             'getfindList': A('getfindList'), // 罚单--列表
             'getdetail': A('getdetail'), // 罚单--详情
             'getfindNames': A('getfindNames'), // 罚单--详情
             'getPunishmentStateEnum': A('getPunishmentStateEnum'), // 罚单--状态
        },
        sagas: {
            'getfindList': S('getfindList', '/?cmd=com.xqxc.api.pig.mis.order.PunishmentService.findList'),
            'getdetail': S('getdetail', '/?cmd=com.xqxc.api.pig.mis.order.PunishmentService.detail'),
            'getfindNames': S('getfindNames', '/?cmd=com.xqxc.api.pig.mis.order.PunishmentTypeService.findNames'),
            'getPunishmentStateEnum': S('getPunishmentStateEnum', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum'),
        },
        reducers: {
            'findList': R('getfindList', { dataList: [], pageNum: 1, pageSize: 25, resultTotal: 0 }),
            'detail': R('getdetail', {}),
            'findNames': R('getfindNames', []),
            'PunishmentStateEnum': R('getPunishmentStateEnum', []),
        }
    })
};
export default createModel(model);